/**
 * Locks page scroll (incl. Lenis smooth scroll) while a modal/overlay is open.
 * Returns an unlock function to restore the previous scroll position.
 */
export function lockPageScroll() {
  const scrollY = window.scrollY;
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  const lenis = typeof window !== "undefined" ? window.__lenis : null;

  if (lenis && typeof lenis.stop === "function") {
    lenis.stop();
  }

  const prev = {
    bodyPosition: document.body.style.position,
    bodyTop: document.body.style.top,
    bodyLeft: document.body.style.left,
    bodyRight: document.body.style.right,
    bodyWidth: document.body.style.width,
    bodyOverflow: document.body.style.overflow,
    bodyPaddingRight: document.body.style.paddingRight,
    htmlOverflow: document.documentElement.style.overflow,
  };

  document.body.style.position = "fixed";
  document.body.style.top = `-${scrollY}px`;
  document.body.style.left = "0";
  document.body.style.right = "0";
  document.body.style.width = "100%";
  document.body.style.overflow = "hidden";
  document.documentElement.style.overflow = "hidden";
  if (scrollbarWidth > 0) {
    document.body.style.paddingRight = `${scrollbarWidth}px`;
  }

  return () => {
    document.body.style.position = prev.bodyPosition;
    document.body.style.top = prev.bodyTop;
    document.body.style.left = prev.bodyLeft;
    document.body.style.right = prev.bodyRight;
    document.body.style.width = prev.bodyWidth;
    document.body.style.overflow = prev.bodyOverflow;
    document.body.style.paddingRight = prev.bodyPaddingRight;
    document.documentElement.style.overflow = prev.htmlOverflow;
    window.scrollTo(0, scrollY);

    if (lenis && typeof lenis.start === "function") {
      lenis.start();
    }
  };
}
